let intendedUrl = null;
let isAddBag = false;
let exitHandlersAttached = false;
let addBugResetTimeout = null;
let addBugObserver = null;

const hideAlertIfQtyPositive = () => {
  const qtyEl = document.querySelector(".mvtotalquantity");
  const alertBox = document.querySelector("#multivariants_setbox_alert");
  if (!qtyEl || !alertBox) return;
  const qty = parseFloat(qtyEl.textContent.trim());
  if (!isNaN(qty) && qty > 0) {
    alertBox.style.setProperty("display", "none", "important");
  }
};

const handleDocumentClick = (event) => {
  const link = event.target.closest("a");
  if (link) {
    intendedUrl = link.href;
    event.preventDefault();
    showModal();
  }
};

const ensureExitHandlers = () => {
  if (addBugResetTimeout) {
    clearTimeout(addBugResetTimeout);
    addBugResetTimeout = null;
  }
  if (exitHandlersAttached || isAddBag) return;
  window.addEventListener("beforeunload", beforeunload);
  document.addEventListener("click", handleDocumentClick);
  exitHandlersAttached = true;
};

const clearExitHandlers = () => {
  if (!exitHandlersAttached) return;
  window.removeEventListener("beforeunload", beforeunload);
  document.removeEventListener("click", handleDocumentClick);
  exitHandlersAttached = false;
};

function beforeunload(event) {
  event.preventDefault();
  const modal = document.getElementById("custom-modal");
  if (modal.style.display === "flex") {
    document.getElementById("stay-button").click();
  }
  event.returnValue =
    "Would you like to add the selected items to your cart?";
}
window.addEventListener("DOMContentLoaded", function () {
  let observerAttached = false;
  let addBugRef = null;

  const addBugDisable = (addBug) => {
    // Ensure the button can receive clicks even if app leaves it disabled.
    addBug.removeAttribute("disabled");
    addBug.style.pointerEvents = "auto";

    if (addBugObserver) {
      addBugObserver.disconnect();
    }
    addBugObserver = new MutationObserver(() => {
      addBug.removeAttribute("disabled");
      addBug.style.pointerEvents = "auto";
    });
    addBugObserver.observe(addBug, { attributes: true, attributeFilter: ["disabled", "style", "class"] });

    addBug.onclick = function (event) {
      const alertBox = document.querySelector("#multivariants_setbox_alert");
      const hasOkNotice =
        alertBox && alertBox.querySelector("span.multivariants_notice_ok");

      if (!hasOkNotice) {
        event.preventDefault();
        if (alertBox) {
          alertBox.style.setProperty("display", "block", "important");
          setTimeout(() => {
            alertBox.style.setProperty("display", "none", "important");
          }, 3000);
        }
        return;
      }

      hideAlertIfQtyPositive();
      clearExitHandlers();
      isAddBag = true;

      if (addBugResetTimeout) {
        clearTimeout(addBugResetTimeout);
      }

      addBugResetTimeout = setTimeout(() => {
        clearExitHandlers();
        isAddBag = false;
        addBugResetTimeout = null;
      }, 5000);

      MultivariantsAddToCart(addBug);
    };
  };

  const observerCall = () => {
    const targetNode = document.querySelector(
      "#multivariants_block_subtotal_price"
    );
    const observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        if (mutation.type === "childList" || mutation.type === "characterData") {
          const moneyElement = targetNode.querySelector(".money");
          if (moneyElement) {
            const moneyText = moneyElement.textContent.trim();
            const moneyValue = parseFloat(moneyText.replace(/[^0-9.]/g, ""));
            hideAlertIfQtyPositive();
            if (moneyValue > 0 && !isAddBag) {
              ensureExitHandlers();
            }
          }
        }
      });
    });

    observer.observe(targetNode, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  };

  let findTotalMoney = setInterval(() => {
    const subtotalNode = document.querySelector(
      "#multivariants_block_subtotal_price"
    );
    const addBug = document.querySelector("#multivariants_add_to_cart_button");

    if (subtotalNode && !observerAttached) {
      observerCall();
      observerAttached = true;
    }

    if (addBug && addBug !== addBugRef) {
      addBugRef = addBug;
      addBugDisable(addBugRef);
    }

    if (observerAttached && addBugRef) {
      clearInterval(findTotalMoney);
    }
  }, 200);
});

function showModal() {
  const modal = document.getElementById("custom-modal");
  modal.style.display = "flex";

  const stayButton = document.getElementById("stay-button");
  const leaveButton = document.getElementById("leave-button");

  stayButton.onclick = () => {
    modal.style.display = "none";
  };

  leaveButton.onclick = () => {
    clearExitHandlers();
    if (intendedUrl) {
      window.location.href = intendedUrl;
    }
  };
}

